var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseMobileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.625 13.5781C16.0469 14.0469 16.0469 14.75 15.625 15.1719C15.1562 15.6406 14.4531 15.6406 14.0312 15.1719L8.5 9.59375L2.92188 15.1719C2.45312 15.6406 1.75 15.6406 1.32812 15.1719C0.859375 14.75 0.859375 14.0469 1.32812 13.5781L6.90625 8L1.32812 2.42188C0.859375 1.95312 0.859375 1.25 1.32812 0.828125C1.75 0.359375 2.45312 0.359375 2.875 0.828125L8.5 6.45312L14.0781 0.875C14.5 0.40625 15.2031 0.40625 15.625 0.875C16.0938 1.29688 16.0938 2 15.625 2.46875L10.0469 8L15.625 13.5781Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseMobileIcon);
export default __webpack_public_path__ + "static/media/closeMobileIcon.093c1c21cc742bdbbc8389294c8ee0e5.svg";
export { ForwardRef as ReactComponent };